import { screenState } from '../user.cache';

export const setStateToBlocked = () => {
  screenState({ isScreenBlocked: true });
};

export const setStateToUnblock = () => {
  screenState({ isScreenBlocked: false });
};

export const useScreenState = () => ({
  setStateToBlocked,
  setStateToUnblock,
});
